jQuery(document).ready(function($) {
  docDownloads();
  //createAccountRedirect();
});

function docDownloads(){
  $('.product-description.rte ul li').each(function() {
    var chk = $(this).find('a').attr('href');
    if(chk != undefined){
      if(chk.indexOf('.pdf') != -1){
        $(this).addClass('PDF');
        $(this).parent('ul').addClass('PDFs');
      }
    }
  });	
}
function createAccountRedirect(){
  $('a#customer_register_link').attr('href','/pages/distributors');
}